"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.notifyOtherTabsOfLogout = notifyOtherTabsOfLogout;
exports.getPrOtherTabLogout = getPrOtherTabLogout;
var tsafe_1 = require("../vendor/frontend/tsafe");
var Deferred_1 = require("../tools/Deferred");
var GLOBAL_CONTEXT_KEY = "__oidc-spa.logoutPropagationToOtherTabs.globalContext";
(_a = window[GLOBAL_CONTEXT_KEY]) !== null && _a !== void 0 ? _a : (window[GLOBAL_CONTEXT_KEY] = {
    appInstanceId: Math.random().toString(36).slice(2)
});
var globalContext = window[GLOBAL_CONTEXT_KEY];
function getChannelName(params) {
    var sessionIdOrConfigId = params.sessionIdOrConfigId;
    return "oidc-spa:logout-propagation:".concat(sessionIdOrConfigId);
}
function notifyOtherTabsOfLogout(params) {
    var redirectUrl = params.redirectUrl, configId = params.configId, sessionId = params.sessionId;
    var message = {
        redirectUrl_initiator: redirectUrl,
        configId: configId,
        appInstanceId: globalContext.appInstanceId
    };
    new BroadcastChannel(getChannelName({ sessionIdOrConfigId: sessionId !== null && sessionId !== void 0 ? sessionId : configId })).postMessage(message);
}
function getPrOtherTabLogout(params) {
    var sessionId = params.sessionId, configId = params.configId, homeUrl = params.homeUrl;
    var dOtherTabLogout = new Deferred_1.Deferred();
    var channel = new BroadcastChannel(getChannelName({ sessionIdOrConfigId: sessionId !== null && sessionId !== void 0 ? sessionId : configId }));
    channel.onmessage = function (_a) {
        var message = _a.data;
        (0, tsafe_1.assert)((0, tsafe_1.is)(message));
        channel.close();
        if (message.appInstanceId === globalContext.appInstanceId) {
            return;
        }
        var redirectUrl = (function () {
            if (configId === message.configId) {
                return message.redirectUrl_initiator;
            }
            return homeUrl;
        })();
        dOtherTabLogout.resolve({ redirectUrl: redirectUrl });
    };
    var prOtherTabLogout = dOtherTabLogout.pr;
    return { prOtherTabLogout: prOtherTabLogout };
}
//# sourceMappingURL=logoutPropagationToOtherTabs.js.map